import { useContext, useEffect, useRef } from 'react';
import { GlobalDataContext } from '@ea-lab/reactive-json';

export const SelectAllHandler = ({ props }) => {
    const globalDataContext = useContext(GlobalDataContext);
    const lastSelectAllRef = useRef(null);

    useEffect(() => {
        const selectAll = globalDataContext.templateData?.selectAll;
        const files = globalDataContext.templateData?.files;

        // Only update if selectAll actually changed
        if (lastSelectAllRef.current !== selectAll && Array.isArray(files) && typeof selectAll === 'boolean') {
            lastSelectAllRef.current = selectAll;
            
            // Update all files' selected property
            files.forEach((file, index) => {
                if (file && typeof file === 'object') {
                    const filePath = `files.${index}.selected`;
                    globalDataContext.updateData(selectAll, filePath);
                }
            });
        }
    }, [globalDataContext.templateData?.selectAll, globalDataContext.templateData?.files, globalDataContext]);

    return null; // This component doesn't render anything
};
